import {
  ComboboxOption as HeadlessComboboxOption,
  type ComboboxOptionProps as HeadlessComboboxOptionProps,
} from "@headlessui/react";
import { classNames } from "../../utils/classNames";

export function ComboboxOption({
  children,
  className,
  ...props
}: HeadlessComboboxOptionProps) {
  return (
    <HeadlessComboboxOption
      as={props.as || "li"}
      className={classNames(
        // Basic layout
        "group/option w-full grid cursor-default grid-cols-[theme(spacing.5),1fr] items-center gap-x-1.5 rounded-lg py-2.5 pl-2.5 pr-3.5 sm:grid-cols-[theme(spacing.4),1fr] sm:py-1.5 sm:pl-2 sm:pr-3 overflow-hidden",

        // Typography
        "text-base/6 text-primary sm:text-sm/6 forced-colors:text-[CanvasText]",

        // Focus
        "outline-none data-[focus]:bg-hover data-[focus]:text-inverse-primary",

        // Forced colors mode
        "forced-color-adjust-none forced-colors:data-[focus]:bg-[Highlight] forced-colors:data-[focus]:text-[HighlightText]",

        // Disabled
        "data-[disabled]:opacity-50",
      )}
      {...props}
    >
      {(props) => (
        <>
          <svg
            className="relative hidden size-5 self-center stroke-current group-data-[selected]/option:inline sm:size-4"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M4 8.5l3 3L12 4"
              strokeWidth={1.5}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span
            className={classNames(
              // Base
              "flex items-center col-start-2 truncate",

              "[&>[data-slot=icon]]:size-5 [&>[data-slot=icon]]:shrink-0 [&>[data-slot=icon]]:text-zinc-500 [&>[data-slot=icon]]:group-data-[focus]/option:text-white sm:[&>[data-slot=icon]]:size-4 forced-colors:[&>[data-slot=icon]]:text-[CanvasText] forced-colors:[&>[data-slot=icon]]:group-data-[focus]/option:text-[Canvas]",

              // Avatars
              "[&>[data-slot=avatar]]:size-6 sm:[&>[data-slot=avatar]]:size-5",
              className,
            )}
          >
            {typeof children === "function" ? children(props) : children}
          </span>
        </>
      )}
    </HeadlessComboboxOption>
  );
}
